import { FC } from 'react';
import Button from '~/components/button';
import Heading from '~/components/heading';
import AppModal from '~/components/modal';
import WYSIWYGContent from '~/components/wysiwyg-content';
import FormSuccessModal from '~/data/strapi/types/shared-blocks/block-customer-form/success-modal';

import styles from './styles.module.css';

interface Props {
  onClose: () => void;
  visible: boolean;
  data: FormSuccessModal;
}

const CustomerFormAcceptModal: FC<Props> = ({ onClose, visible, data }) => {
  const { heading, description, buttonTitle } = data;
  return (
    <AppModal visible={visible} onClose={onClose}>
      <article className={styles.container}>
        {heading && <Heading data={heading} />}
        {description && <WYSIWYGContent html={description} />}
        <Button onClick={onClose} className={styles.btn} title={buttonTitle || 'Oк'} />
      </article>
    </AppModal>
  );
};

export default CustomerFormAcceptModal;
